var React = require('react');

function VolumeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.072.372a1.125 1.125 0 10-.642 2.157 6.754 6.754 0 010 12.942 1.125 1.125 0 10.642 2.157 9.004 9.004 0 000-17.256z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M16.547 5.954a1.125 1.125 0 00-1.591 1.591c.55.551.795.824.795 1.455 0 .63-.245.904-.795 1.454a1.125 1.125 0 001.59 1.592l.03-.03C17.15 11.444 18 10.593 18 9s-.85-2.443-1.425-3.016l-.03-.03zm-4.171-3.699c0-1.927-2.262-2.962-3.72-1.704L4.081 4.5H2.25A2.25 2.25 0 000 6.75v4.501a2.25 2.25 0 002.25 2.25h1.832l4.573 3.949c1.458 1.258 3.721.223 3.721-1.704V2.255z","fill":"currentColor","key":1})]);
}

VolumeInline.defaultProps = {"width":"23","height":"18","fill":"none"};

module.exports = VolumeInline;

VolumeInline.default = VolumeInline;
